













































































import Vue from 'vue'
import Component from 'vue-class-component'
import { Invoice } from '@/core/ApiTypes'
import appManager from '@/services/AppManager'
import * as db from '@/core/Database'
import * as api from '@/services/ApiService'
import Spinner from '@/components/Spinner.vue'
import { InvoiceStatusTypes } from '@/extern/StripeTypes'
import { AppColors } from '@/model/AppColors'
import { getCurrencyText, getDateTextFromMillis } from '@/model/Helpers'

@Component({
    components: {
        Spinner
    }
})
export default class InvoicesView extends Vue {
    isLoadingCompany: boolean = true
    companyId: string|undefined
    stripeCustomerId: string|undefined

    isLoadingInvoices: boolean = false
    invoices: Invoice[] = []
    hasMoreInvoices: boolean = false

    // noinspection JSUnusedGlobalSymbols
    async created() {
        const user = appManager.userManager.state?.user
        if (user && user.data.companyId) {
            const company = await db.getCompanyData(user.data.companyId)
            this.companyId = user.data.companyId
            this.stripeCustomerId = company?.stripeCustomerId
            this.isLoadingCompany = false

            if (this.stripeCustomerId)
                await this.loadMoreInvoices()
        }
    }

    async loadMoreInvoices(): Promise<void> {
        this.isLoadingInvoices = true

        try {
            const response = await api.queryInvoices({
                companyId: this.companyId,
                stripeCustomerId: this.stripeCustomerId,
                startAfterStripeInvoiceId: (this.invoices.length > 0) ? this.invoices[this.invoices.length-1].id : undefined
            })
            for (const invoice of response.invoices)
                this.invoices.push(invoice)
            this.hasMoreInvoices = response.hasMore
        } catch (error) {
            console.error(`Error Loading Invoices: ${error}`)
        }

        this.isLoadingInvoices = false
    }

    getInvoiceStatusColor(invoice: Invoice): string {
        const status = invoice?.data?.status
        switch (status) {
            case InvoiceStatusTypes.deleted:
                return AppColors.secondary;
            case InvoiceStatusTypes.draft:
                return AppColors.info;
            case InvoiceStatusTypes.open:
                return AppColors.info;
            case InvoiceStatusTypes.paid:
                return AppColors.success;
            case InvoiceStatusTypes.uncollectible:
                return AppColors.error;
            case InvoiceStatusTypes.void:
                return AppColors.info;
        }

        return AppColors.info
    }

    getInvoiceStatusText(invoice: Invoice): string {
        const status = invoice?.data?.status
        switch (status) {
            case InvoiceStatusTypes.deleted:
                return 'DELETED';
            case InvoiceStatusTypes.draft:
                return 'DRAFT';
            case InvoiceStatusTypes.open:
                return 'OPEN';
            case InvoiceStatusTypes.paid:
                return 'PAID';
            case InvoiceStatusTypes.uncollectible:
                return 'UNCOLLECTIBLE';
            case InvoiceStatusTypes.void:
                return 'VOID';
        }

        return 'UNKNOWN'
    }

    getAmountText(invoice: Invoice): string {
        return getCurrencyText(invoice.data.total)
    }

    getDateTextFromMillisLocal(millis: number|null|undefined): string {
        return getDateTextFromMillis(millis)
    }

    isDetailViewEnabled(invoice: Invoice): boolean {
        return !!invoice.data?.hostedInvoiceUrl
    }
}
